// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Address, type AddressWireFormat, NewAddress } from '../Address/Address';
import {
  type CompanyMatchInfo,
  type CompanyMatchInfoWireFormat,
  NewCompanyMatchInfo,
} from '../CompanyMatchInfo/CompanyMatchInfo';
import Enums from '../Enums';

export class UnlinkedDispatchCustomer {
  readonly id: string;
  readonly name: string;
  readonly code: string | null;
  readonly creditStatusCode: string | null;
  readonly creditStatusDescription: string | null;
  readonly address: Address | null;
  readonly matchInfo: CompanyMatchInfo[] | null;
  readonly integrationId: string;
  readonly integrationName: string;
  readonly integrationType: Enums.IntegrationType;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.code = data.code === undefined ? null : data.code;
    this.creditStatusCode = data.creditStatusCode === undefined ? null : data.creditStatusCode;
    this.creditStatusDescription =
      data.creditStatusDescription === undefined ? null : data.creditStatusDescription;
    this.address =
      // eslint-disable-next-line no-nested-ternary
      (data.address ?? null) === null ? null : NewAddress(data.address);
    this.matchInfo =
      // eslint-disable-next-line no-nested-ternary
      (data.matchInfo ?? null) === null
        ? null
        : (data.matchInfo ?? []).map((matchInfo: any) => NewCompanyMatchInfo(matchInfo));
    this.integrationId = data.integrationId === undefined ? NIL_UUID : data.integrationId;
    this.integrationName = data.integrationName === undefined ? '' : data.integrationName;
    this.integrationType =
      data.integrationType === undefined ? Enums.IntegrationType.Series : data.integrationType;
  }

  static zero(): UnlinkedDispatchCustomer {
    const zeroValues: ExcludeMethodsDeep<UnlinkedDispatchCustomer> = {
      id: NIL_UUID,
      name: '',
      code: null,
      creditStatusCode: null,
      creditStatusDescription: null,
      address: null,
      matchInfo: null,
      integrationId: NIL_UUID,
      integrationName: '',
      integrationType: Enums.IntegrationType.Series,
    };
    return new UnlinkedDispatchCustomer(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UnlinkedDispatchCustomerWireFormat = {
  id: string;
  name: string;
  code: string | null;
  creditStatusCode: string | null;
  creditStatusDescription: string | null;
  address: AddressWireFormat | null;
  matchInfo: CompanyMatchInfoWireFormat[] | null;
  integrationId: string;
  integrationName: string;
  integrationType: string;
};

type NewUnlinkedDispatchCustomerProps = PartialDeep<
  UnlinkedDispatchCustomer,
  { recurseIntoArrays: true }
>;
export const NewUnlinkedDispatchCustomer: (
  props: NewUnlinkedDispatchCustomerProps,
) => UnlinkedDispatchCustomer = (props) => new UnlinkedDispatchCustomer(props);

type NewUnlinkedDispatchCustomerFromWireFormatProps = PartialDeep<
  UnlinkedDispatchCustomerWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUnlinkedDispatchCustomerFromWireFormat: (
  props: NewUnlinkedDispatchCustomerFromWireFormatProps,
) => UnlinkedDispatchCustomer = (props) => new UnlinkedDispatchCustomer(props);
